import { KeyRound } from "lucide-react";
import { FormEvent, useState } from "react";
import { ApiError } from "../api";
import { useAuth } from "../auth";

export function ChangePasswordDialog() {
  const { changePassword } = useAuth();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError("");
    if (newPassword !== confirmPassword) {
      setError("Mật khẩu nhập lại chưa khớp.");
      return;
    }

    setSubmitting(true);
    try {
      await changePassword(currentPassword, newPassword);
    } catch (reason) {
      setError(reason instanceof ApiError ? reason.message : "Không đổi được mật khẩu.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="dialog-backdrop">
      <section className="dialog-card" role="dialog" aria-modal="true">
        <div className="dialog-icon">
          <KeyRound size={28} />
        </div>
        <h2>Đổi mật khẩu lần đầu</h2>
        <p>
          Tài khoản quản trị ban đầu phải đổi mật khẩu trước khi tiếp tục sử dụng hệ thống.
        </p>
        <form onSubmit={submit} className="stack-form">
          <label>
            Mật khẩu hiện tại
            <input
              type="password"
              value={currentPassword}
              onChange={(event) => setCurrentPassword(event.target.value)}
              autoComplete="current-password"
              required
            />
          </label>
          <label>
            Mật khẩu mới
            <input
              type="password"
              value={newPassword}
              onChange={(event) => setNewPassword(event.target.value)}
              autoComplete="new-password"
              minLength={8}
              required
            />
          </label>
          <label>
            Nhập lại mật khẩu mới
            <input
              type="password"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              autoComplete="new-password"
              minLength={8}
              required
            />
          </label>
          <small>Ít nhất 8 ký tự, gồm chữ hoa, chữ thường và số.</small>
          {error && <div className="form-error">{error}</div>}
          <button className="primary-button" type="submit" disabled={submitting}>
            {submitting ? "Đang cập nhật..." : "Đổi mật khẩu"}
          </button>
        </form>
      </section>
    </div>
  );
}
